import React from 'react';
import { Typography, Alert } from '@mui/material';
import s from './BookingDetailsPage.module.scss';
import { format } from 'date-fns';
import { FIELD_LABEL_TRANSLATIONS } from '../../assets/translations/translations'; // import translation map
import Button from '@mui/material/Button';

const ReviewStep = ({ product, selectedSession, bookingData, formData, error,  onAddToCart,
                        onCheckout}) => {
    const translateLabel = (label) => FIELD_LABEL_TRANSLATIONS[label] || label;

    const baseSubtotal = product.priceOptions.reduce((sum, option) => {
        const qty = bookingData.quantities[option.id] || 0;
        return sum + qty * option.price;
    }, 0);

    const extrasSubtotal = Object.entries(formData.extras).reduce((sum, [name, qty]) => {
        const extra = product.extras?.find(e => e.name === name);
        return sum + qty * (extra?.price || 0);
    }, 0);

    const grandTotal = baseSubtotal + extrasSubtotal;


    return (
        <div className={s.reviewModern}>
            <Typography className={s.pageTitle}>
                予約内容の確認
            </Typography>

            <Typography className={s.pageSubtitle}>
                内容をご確認のうえ、予約へ進んでください
            </Typography>

            <div className={s.mainCard}>

                {/* TOUR INFO */}
                <div className={s.section}>
                    <h3 className={s.sectionTitle}>ツアー情報</h3>

                    <div className={s.infoRow}>
                        <span>ツアー名</span>
                        <strong>{product.name}</strong>
                    </div>

                    <div className={s.infoRow}>
                        <span>日付</span>
                        <strong>
                            {format(
                                new Date(selectedSession.startTimeLocal),
                                'yyyy年M月d日 (EEE)'
                            )}
                        </strong>
                    </div>

                    <div className={s.infoRow}>
                        <span>参加人数</span>
                        <strong>{bookingData.totalParticipants}名</strong>
                    </div>

                    {product.pickupLocations?.length > 0 && (
                        <div className={s.infoRow}>
                            <span>ピックアップ</span>
                            <strong>
                                {formData.pickup || 'なし'}
                            </strong>
                        </div>
                    )}
                </div>

                {/* BOOKING FIELDS */}
                {product.bookingFields?.some(
                    f => f.visiblePerBooking || f.requiredPerBooking
                ) && (
                    <div className={s.section}>
                        <h3 className={s.sectionTitle}>予約者情報</h3>

                        {product.bookingFields
                            .filter(
                                f =>
                                    f.visiblePerBooking ||
                                    f.requiredPerBooking
                            )
                            .map(field => (
                                <div
                                    key={field.label}
                                    className={s.infoRow}
                                >
                                <span>
                                    {translateLabel(field.label)}
                                </span>

                                    <strong>
                                        {formData.bookingFields[
                                            field.label
                                            ] || (
                                            field.requiredPerBooking
                                                ? (
                                                    <span
                                                        className={
                                                            s.missing
                                                        }
                                                    >
                                                    未入力
                                                </span>
                                                )
                                                : '未入力'
                                        )}
                                    </strong>
                                </div>
                            ))}
                    </div>
                )}

                {/* PARTICIPANTS */}
                {formData.participants.length > 0 && (
                    <div className={s.section}>
                        <h3 className={s.sectionTitle}>
                            参加者情報
                        </h3>

                        {formData.participants.map(
                            (participant, idx) => (
                                <div
                                    key={idx}
                                    className={
                                        s.participantCardModern
                                    }
                                >
                                    <div
                                        className={
                                            s.participantHeader
                                        }
                                    >
                                        参加者 {idx + 1}
                                    </div>

                                    {product.bookingFields
                                        ?.filter(
                                            f =>
                                                f.visiblePerParticipant ||
                                                f.requiredPerParticipant
                                        )
                                        .map(field => (
                                            <div
                                                key={field.label}
                                                className={
                                                    s.infoRow
                                                }
                                            >
                                            <span>
                                                {translateLabel(
                                                    field.label
                                                )}
                                            </span>

                                                <strong>
                                                    {participant[
                                                        field.label
                                                        ] || (
                                                        field.requiredPerParticipant
                                                            ? (
                                                                <span
                                                                    className={
                                                                        s.missing
                                                                    }
                                                                >
                                                                未入力
                                                            </span>
                                                            )
                                                            : '未入力'
                                                    )}
                                                </strong>
                                            </div>
                                        ))}
                                </div>
                            )
                        )}
                    </div>
                )}
            </div>

            {/* CTA */}
            <div className={s.stickyFooter}>
                <Button
                    variant="contained"
                    onClick={onCheckout}
                    className={s.confirmBtn}
                >
                    このまま予約する
                </Button>
            </div>

            {error && (
                <Alert severity="error" className="mt-4">
                    {error}
                </Alert>
            )}
        </div>
    );

};

export default ReviewStep;